module.exports = __webpack_public_path__ + "static/img/role.ba47de7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/wxsjglm/role.png
// module id = 7YBL
// module chunks = 7